import { render } from "./DownloadIcon.vue?vue&type=template&id=14e8058a&scoped=true"
const script = {}

import "./DownloadIcon.vue?vue&type=style&index=0&id=14e8058a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e8058a"]])

export default __exports__